function toggleNavigation(menu) {
    menu.classList.toggle('open');
}

function showAlergens(elem) {
    var tooltip = elem.parent().find('.alergens-list-mobile');

    if(tooltip.is(':visible')){
        $(document).find('.alergens-list-mobile').hide(); // Hide all
    }else{
        $(document).find('.alergens-list-mobile').hide(); // Hide all
        tooltip.show();
    }
}

$(document).ready(function(){

    $(document).click(function(e) {
        if ( $(e.target).closest('.alergens-mobile').length === 0 ) {
            $(document).find('.alergens-list-mobile').hide(); // Hide all
        }
    });
    $(document).on('click', '.alergens-mobile', function(e){
        e.preventDefault();
        showAlergens($(this));
    });
    $(document).on('touch', '.alergens-mobile', function(e){
        e.preventDefault();
        showAlergens($(this));
    });

    var modal = document.getElementById('modal-login');
    var btn = document.getElementById('modal-button');
    var span = document.getElementsByClassName('close')[0];

    if(btn){
    // When the user clicks the button, open the modal
        btn.onclick = function() {
            modal.style.display = 'block';
        };
    }

    if(span){
        // When the user clicks on <span> (x), close the modal
        span.onclick = function() {
            modal.style.display = 'none';
        };
    }

    var modalSearch = document.getElementById('modal-search');
   // var btnSearch = document.getElementById('open-search-modal');
    var spanSearch = document.getElementById('close-search');
    var modalRemaining = document.getElementById('modal-remaining');
    var spanRemaining = document.getElementById('close-remaining');

    // When the user clicks the button, open the modal
    $(document).on('click', '#open-search-modal', function (){
        modalSearch.style.display = 'block';
        $(document).find('#search-user').focus();
    });

    if(spanSearch){
        // When the user clicks on <span> (x), close the modal
        spanSearch.onclick = function() {
            modalSearch.style.display = 'none';
        };
    }

    if(spanRemaining){
        // When the user clicks on <span> (x), close the modal
        spanRemaining.onclick = function() {
            modalRemaining.style.display = 'none';
        };
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
        if (event.target === modalSearch) {
            modalSearch.style.display = 'none';
        }
        if (event.target === modalRemaining) {
            modalRemaining.style.display = 'none';
        }
    };

    $(document).on('click', '.nav-admin', function (e){
        e.preventDefault();
        window.location.href = $(this).find('a').attr('href');
    });

});

$(document).on("click", ".modal-ask", function (e) {
    e.preventDefault();
    let link = $(this);
    let ask = "Opravdu chcete odebrat tento záznam?";

    if(isDefined(link.data("ask"))){
        ask = link.data("ask");
    }

    let confirmDialog = new ConfirmDialog(ask, {
        event: e
    });

    confirmDialog.create(function (result) {
        if(result){
            let url = link.data("href");
            let ajax = link.data("ajax");

            if(ajax === "on") {
                $.nette.ajax({
                    url: url,
                    type: 'GET',
                    off: {
                        snippets: true
                    }
                });
            } else {
                window.location.href = url;
            }
        }
    });

});

let creditSticker;
let eshopModeCart;
var stickyOffset;
$(document).ready(function() {
    var header = $('#header-container'); // Vyberte element hlavičky
    if(!header) return;
    stickyOffset = header.outerHeight(); // Aktualizace pozice hlavičky
    creditSticker = $(document).find(".credit-sticker");
    eshopModeCart = $('.restaurant-name > .food-basket');
    if(creditSticker) {
        $(window).scroll(function() {
            checkCreditSticker();
        });
    }
});

function checkCreditSticker(){
    if (window.scrollY > stickyOffset) {
        if(!creditSticker.isVisible()){
            creditSticker.show();
            eshopModeCart.hide();
        }
    } else {
        if(creditSticker.isVisible()){
            creditSticker.hide();
            eshopModeCart.show();
        }
    }
}

$( document ).on( "ajaxComplete", function() {
    creditSticker = $(document).find(".credit-sticker");
    if (creditSticker) {
        checkCreditSticker();
    }
} );